export const editPassword = gql`
    mutation editPassword(
        $password: String
        $newPassword: String
    ) {
        updateMe(
            input:{
                password: $password,
                newPassword: $newPassword,
            }) {
                id
            }
    }
`
